const API_URL = import.meta.env.VITE_API_URL || '';

function requireTenantId(tenantId) {
  if (!tenantId || !String(tenantId).trim()) {
    const error = new Error('Tenant is required');
    error.code = 'TENANT_REQUIRED';
    throw error;
  }
  return String(tenantId).trim();
}

async function fetchJson(path, tenantId) {
  const tenant = requireTenantId(tenantId);
  const response = await fetch(`${API_URL}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      'x-tenant-id': tenant
    }
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.ok === false) {
    throw new Error(payload.error || `QorIAX API error ${response.status}`);
  }

  return payload;
}

export async function fetchTenantConfig(tenantId) {
  const tenant = requireTenantId(tenantId);
  const payload = await fetchJson(`/api/tenant/config?tenant_id=${encodeURIComponent(tenant)}`, tenant);
  return payload.data;
}

export async function fetchTenantModules(tenantId) {
  const tenant = requireTenantId(tenantId);
  const payload = await fetchJson(`/api/modules?tenant_id=${encodeURIComponent(tenant)}`, tenant);
  return payload.data || [];
}

export async function fetchPlatformBootstrap(tenantId) {
  const tenant = requireTenantId(tenantId);
  const [tenantConfig, modules] = await Promise.all([
    fetchTenantConfig(tenant),
    fetchTenantModules(tenant)
  ]);

  return { tenant: tenantConfig, modules };
}
